import { t } from "@lingui/macro";

import { getSectionIcon } from "../../shared/section-icon";
import AIChatContent from "./ai-chart-content";

export const SecAIChat = (props: { onClose: () => void }) => {
  const { onClose } = props;
  return (
    <section id="sec-ai-chat" className="box-border flex max-h-full flex-1 flex-col gap-y-6">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-x-4">
          {getSectionIcon("sec-ai-chat")}
          <h2 className="line-clamp-1 text-3xl font-bold">{t`SecAIChat`}</h2>
        </div>
      </header>

      <main className="flex flex-1 flex-col gap-y-4 overflow-y-auto">
        <AIChatContent onClose={onClose} />
      </main>
    </section>
  );
};
